<template>
  <v-list dense class="transparent pa-0">
    <v-list-item
      class="mb-2 custom-grey"
      :to="{ name: 'inboxPageWithFilter', params: { filter: 'inbox' } }"
    >
      <v-list-item-icon class="mr-4">
        <v-icon>$inboxReceived</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <span class="title-font font-weight-medium"> INBOX </span>
      </v-list-item-content>
      <v-list-item-action>
        <v-avatar size="20" color="primary">
          <small class="white--text">
            {{ countInStatus("inbox") }}
          </small>
        </v-avatar>
      </v-list-item-action>
    </v-list-item>
    <v-list-item
      class="mb-2 custom-grey"
      :to="{ name: 'inboxPageWithFilter', params: { filter: 'exported' } }"
    >
      <v-list-item-icon class="mr-4">
        <v-icon>$implantExport</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <span class="title-font font-weight-medium"> IMPLANTS EXPORTED </span>
      </v-list-item-content>
      <v-list-item-action>
        <v-avatar size="20" color="secondary">
          <small class="white--text">
            {{ countInStatus("exported") }}
          </small>
        </v-avatar>
      </v-list-item-action>
    </v-list-item>
    <v-list-item
      class="mb-2 custom-grey"
      :to="{
        name: 'inboxPageWithFilter',
        params: { filter: 'waiting' }
      }"
    >
      <v-list-item-icon class="mr-4">
        <v-icon>$alarm</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <span class="title-font font-weight-medium"> AWAITING RESPONSE </span>
      </v-list-item-content>
      <v-list-item-action>
        <v-avatar size="20" color="warning">
          <small class="white--text">
            {{ awaitingResponseCount() }}
          </small>
        </v-avatar>
      </v-list-item-action>
    </v-list-item>
    <v-list-item
      class="mb-2 custom-grey"
      :to="{
        name: 'inboxPageWithFilter',
        params: { filter: 'new_message' }
      }"
    >
      <v-list-item-icon class="mr-4">
        <v-icon color="#333F48">mdi-message-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <span class="title-font font-weight-medium"> NEW MESSAGE </span>
      </v-list-item-content>
      <v-list-item-action>
        <v-avatar size="20" color="primary">
          <small class="white--text">
            {{ newMessageCount() }}
          </small>
        </v-avatar>
      </v-list-item-action>
    </v-list-item>
    <v-list-item
      class="mb-2 custom-grey"
      :to="{ name: 'inboxPageWithFilter', params: { filter: 'all' } }"
    >
      <v-list-item-icon class="mr-4">
        <v-icon>$inbox</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <span class="title-font font-weight-medium"> ALL CASES </span>
      </v-list-item-content>
    </v-list-item>
    <v-list-item
      class="mb-2 custom-grey"
      :to="{ name: 'inboxPageWithFilter', params: { filter: 'archived' } }"
    >
      <v-list-item-icon class="mr-4">
        <v-icon>$inboxArchive</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <span class="title-font font-weight-medium"> ARCHIVED CASES </span>
      </v-list-item-content>
    </v-list-item>
    <v-card-text class="pb-0 text--secondary title-font font-weight-light">
      SUBMITTED ORDERS
    </v-card-text>
    <v-list-item
      v-if="featureFlags && featureFlags.designs"
      class="mb-2 custom-grey"
      :to="{ name: 'inboxPageWithFilter', params: { filter: 'design' } }"
    >
      <v-list-item-icon class="mr-4">
        <v-icon>$toothDesigns</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <span class="title-font font-weight-medium"> DESIGN ONLY </span>
      </v-list-item-content>
      <v-list-item-action>
        <v-avatar size="20" color="primary">
          <small class="white--text">
            {{ countInStatus("design") }}
          </small>
        </v-avatar>
      </v-list-item-action>
    </v-list-item>
    <v-list-item
      class="mb-2 custom-grey"
      :to="{ name: 'inboxPageWithFilter', params: { filter: 'bar' } }"
      v-if="featureFlags && featureFlags.bars"
    >
      <v-list-item-icon class="mr-4">
        <v-icon>$milledBar</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <span class="title-font font-weight-medium"> MILLED BAR </span>
      </v-list-item-content>
      <v-list-item-action>
        <v-avatar size="20" color="primary">
          <small class="white--text">
            {{ countInStatus("bar") }}
          </small>
        </v-avatar>
      </v-list-item-action>
    </v-list-item>
    <v-list-item
      class="mb-2 custom-grey"
      :to="{ name: 'inboxPageWithFilter', params: { filter: 'finished_case' } }"
      v-if="featureFlags && featureFlags.finished_cases"
    >
      <v-list-item-icon class="mr-4">
        <v-icon>$finishedProsthetic</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <span class="title-font font-weight-medium"> FINISHED CASES </span>
      </v-list-item-content>
      <v-list-item-action>
        <v-avatar size="20" color="primary">
          <small class="white--text">
            {{ countInStatus("finished_case") }}
          </small>
        </v-avatar>
      </v-list-item-action>
    </v-list-item>
    <v-list-item
      class="mb-2 custom-grey"
      :to="{
        name: 'inboxPageWithFilter',
        params: { filter: 'virtual_smile_design' }
      }"
      v-if="featureFlags && featureFlags.virtual_smile_designs"
    >
      <v-list-item-icon class="mr-4">
        <v-icon>$virtualSmileDesign</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <span class="title-font font-weight-medium">
          VIRTUAL SMILE DESIGNS
        </span>
      </v-list-item-content>
      <v-list-item-action>
        <v-avatar size="20" color="primary">
          <small class="white--text">
            {{ countInStatus("virtual_smile_design") }}
          </small>
        </v-avatar>
      </v-list-item-action>
    </v-list-item>
    <v-list-item
      class="mb-2 custom-grey"
      :to="{
        name: 'inboxPageWithFilter',
        params: { filter: 'immediate' }
      }"
      v-if="featureFlags && featureFlags.immediate_designs"
    >
      <v-list-item-icon class="mr-4">
        <v-icon>$surgicalTool</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <span class="title-font font-weight-medium"> IMMEDIATE CASES </span>
      </v-list-item-content>
      <v-list-item-action>
        <v-avatar size="20" color="primary">
          <small class="white--text">
            {{ countInStatus("immediates") }}
          </small>
        </v-avatar>
      </v-list-item-action>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "InboxActions",

  computed: {
    ...mapGetters(["inboxItems", "featureFlags"])
  },

  methods: {
    countInStatus(status) {
      if (this.inboxItems === null) return 0
      if (status === "immediates")
        return this.inboxItems.filter((item) =>
          item.statuses.some((s) => s.includes("immediate"))
        ).length
      return this.inboxItems.filter((item) => item.statuses.includes(status))
        .length
    },

    awaitingResponseCount() {
      if (this.inboxItems === null) return 0
      return this.inboxItems.filter((item) => item.awaiting_response).length
    },

    newMessageCount() {
      if (this.inboxItems === null) return 0
      return this.inboxItems.filter((item) => item.new_message).length
    }
  }
}
</script>
